import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useFetchData } from "../../../helpers/api";
import { Link } from "react-router-dom";
import DashboardLayout from "../DashboardLayout";
import LoadingScreen from "../../../components/loading/LoadingScreen";
import { ordersDurationOptions } from "../data";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { handleGlobalInputChange } from "../../../helpers/functions";
const customerId = Cookies.get("kalista-web-Id");

const MyOrders = () => {
  const fromDateRef = useRef(null);
  const savedDuration = sessionStorage.getItem("order_duration");
  const [orderDuration, setOrderDuration] = useState(savedDuration || "3");
  const [pazeSize, setPageSize] = useState("5");
  const [formData, setFormData] = useState({ fromDate: "", toDate: "" });
  const [pageNo, setPageNo] = useState(1);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      return updated;
    });
  };

  useEffect(() => {
    const today = new Date();
    const pastDate = new Date();
    pastDate.setMonth(today.getMonth() - parseInt(orderDuration, 10));
    const formatDate = (date) => {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    };
    setFormData({
      fromDate: formatDate(pastDate),
      toDate: formatDate(today),
    });
  }, [orderDuration]);

  const handleOrderDurationChange = (e) => {
    const value = e.target.value;
    setOrderDuration(value);
    sessionStorage.setItem("order_duration", value);

    if (value === "custom") {
      setTimeout(() => {
        if (fromDateRef.current) {
          fromDateRef.current.showPicker?.(); // Try to show the calendar
          fromDateRef.current.focus(); // Fallback
        }
      }, 0)
    };

    // if (value === "custom") {
    //   // Temporarily reset value so "custom" can be selected again later
    //   setOrderDuration("");
    //   setTimeout(() => {
    //     setOrderDuration("custom");
    //     sessionStorage.setItem("order_duration", "custom");
    //     if (fromDateRef.current) {
    //       fromDateRef.current.showPicker?.();
    //       fromDateRef.current.focus();
    //     }
    //   }, 0);
    // } else {
    //   setOrderDuration(value);
    //   sessionStorage.setItem("order_duration", value);
    // }
  }

  const { data: orderData, isLoading } = useFetchData(
    ["singleOrderData", formData.fromDate, formData.toDate, pazeSize, pageNo],
    "/Customer/getAllQuotation",
    {
      CustomerCode: customerId,
      FromDate: formData.fromDate,
      ToDate: formData.toDate,
      PageSize: pazeSize,
      PageNo: pageNo.toString(),
    },
    null,
    {
      enabled: !!customerId && !!formData.fromDate && !!formData.toDate,
      staleTime: 10 * 60 * 1000,
      keepPreviousData: true,
    }
  );
  const totalPages = Math.ceil(orderData?.totalProducts / pazeSize);
  const handlePageClick = (page) => {
    if (isLoading) return;
    if (page >= 1 && page <= totalPages) {
      setPageNo(page);
    }
  };
  const getPageNumbers = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (pageNo === 1) {
      return [1, 2, 3];
    }

    if (pageNo === totalPages) {
      return [totalPages - 2, totalPages - 1, totalPages];
    }

    return [pageNo - 1, pageNo, pageNo + 1];
  };

  return (
    <DashboardLayout pageClass="order_page">
      <div className="dashboard_content">
        <div className="dashboard_top_block">
          <div className="dashboard_top_left">
            <select
              name="order_page_size"
              id="order_page_size"
              value={pazeSize}
              onChange={(e) => setPageSize(e.target.value)}
              disabled={isLoading}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
            </select>
            <div className="order_pagination_con">
              <button
                disabled={pageNo === 1}
                onClick={() => handlePageClick(pageNo - 1)}
                className="pagination_arrows"
              >
                <IoIosArrowBack size="20px" />
              </button>

              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  onClick={() => handlePageClick(page)}
                  className={
                    pageNo === page
                      ? "pagination_numbers active"
                      : "pagination_numbers"
                  }
                >
                  {page}
                </button>
              ))}

              <button
                disabled={pageNo === totalPages}
                onClick={() => handlePageClick(pageNo + 1)}
                className="pagination_arrows"
              >
                <IoIosArrowForward size="20px" />
              </button>
            </div>
          </div>
          <div className="fromDate_toDate_con">
            <div className="fromDate">
              From: <input
                ref={fromDateRef}
                type="date"
                name="fromDate"
                disabled={orderDuration !== "custom"}
                // value={formData.fromDate} not show within api response to in filed to select 3 month to fromdate 23-04-2025 todate 23-05-2025 with dynamic api response
                onChange={handleDateChange}
              />
            </div>
            <div className="toDate">
              To: <input
                type="date"
                name="toDate"
                disabled={orderDuration !== "custom"}
                // value={formData.toDate} not show within api response to in filed to select 3 month to fromdate 23-04-2025 todate 23-05-2025 with dynamic api response
                onChange={handleDateChange}
              />
            </div>

            <select
              name="order_page_duration"
              id="order_page_duration"
              className="order-3 order-sm-1"
              value={orderDuration}
              onChange={handleOrderDurationChange}
              disabled={isLoading}
            >
              {ordersDurationOptions &&
                ordersDurationOptions.map((option) => (
                  <option value={option.value} key={option.value}>
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
        </div>
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <div className="orders_block_con">
            {orderData?.quotationProducts?.Data?.length ? (
              orderData.quotationProducts?.Data.map((item) => (
                <div key={item.OrderId} className="order_block">
                  <img
                    src={process.env.REact_APP_IMG_URL + item.ImagePath}
                    alt={item.OrderNo}
                  />
                  <div className="left_info_con">
                    <Link to={`/order/${item.OrderId}`} className="order_title">
                      #{item.OrderNo}
                    </Link>
                    <div className="order_id">
                      ORDER ID: <span>{item.OrderId}</span>
                    </div>
                    <p className="order_po_no">
                      PO NO: <span>{item.PoNo}</span>
                    </p>
                    <p className="order_qty">
                      QTY: <span>{item.ItemQty}</span>
                    </p>
                    <p className="order_weight">
                      <span>
                        {item.GoldWt} GM | {item.ClientDiamondWt} CT
                      </span>
                    </p>
                  </div>
                  <div className="right_info_con">
                    <p className="order_status">
                      Labour Amount: <span>{item.Amount}</span>
                    </p>
                    <p className="order_salesperson">
                      Sales Person: <span>{item.SalesPersonName}</span>
                    </p>
                    <p className="order_secondStatus">
                      Billing Type: <span>{item.BillingType}</span>
                    </p>
                    {item.IsShowDate === true && (
                      <div className="order_date_con">
                        <p className="order_delivery">
                          Estimated Delivery : <span>15 Days</span>
                        </p>
                        <p className="order_date">
                          Order Date:{" "}
                          <span>
                            {new Intl.DateTimeFormat("en-US", {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            }).format(
                              new Date(parseInt(item.OrderDate.match(/\d+/)[0]))
                            )}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p>No orders found</p>
            )}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MyOrders;
